import VectorRenderTileClass, * as VectorRenderTileModule from './../node_modules/ol/VectorRenderTile.js';

// Create a wrapper class
class VectorRenderTile extends VectorRenderTileClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in VectorRenderTileModule) {
    if (key !== "default") {
        VectorRenderTile[key] = VectorRenderTileModule[key];
    }
}

export default VectorRenderTile;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/VectorRenderTile.js';